<script setup lang="ts">
import type { PropType } from 'vue';

import type { SaleAssetBusEntity } from '~/apiClient';
import type { PlatformSaleItemEntity } from '~/types/sale.type';

// PROPS
const { sale, assetId } = defineProps({
    sale: { type: Object as PropType<PlatformSaleItemEntity>, required: true },
    assetId: { type: String, default: undefined },
});

// COMPOSABLES
const { isTrustReportEligible } = useTrustReport(() => sale);

// COMPUTED
const asset = computed<SaleAssetBusEntity | undefined>(() => sale.assets.find(_a => _a.id === assetId));
</script>

<template>
    <div v-if="asset" class="flex flex-col gap-6" :class="{ 'rounded-xl border border-neutral-300 p-6': !isTrustReportEligible }">
        <SdpMultiGallery :asset="asset" :sale="sale" />

        <SdpMaybeTrustReportWrapper :sale="sale" :asset-id="assetId">
            <BaseI18nT v-if="!isTrustReportEligible" tag="h2" keypath="sdp.multi.detailTitle" class="text-2xl font-bold">
                <template #name>
                    <span class="text-primary">{{ asset.brand.brandValue }} {{ asset.model.modelValue }}</span>
                </template>
            </BaseI18nT>
            <SdpSpecs :sale="sale" :asset-id="assetId" />
            <SdpDetails :sale="sale" :asset-id="assetId" />
            <SdpDocuments :asset="asset" />
        </SdpMaybeTrustReportWrapper>

        <MktgTrustReport />
    </div>
</template>
